<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

const store = useStore();
const info = computed(() => store.state.appInfo);
</script>
<template>
  <div class="banner-imgs-box">
    <ul class="banner-imgs">
      <li
        v-for="(item, index) in info.banner"
        :key="index"
        @click="handleConfirm">
        <img
          :src="item.src"
          alt="" />
      </li>
    </ul>
  </div>
</template>
<style lang="scss" scoped>
.banner-imgs-box {
  overflow-x: auto;
  overflow-y: hidden;
  margin-bottom: 20px;
  .banner-imgs {
    display: flex;
    flex-wrap: nowrap;
    width: fit-content;
    height: 224px;
  }
  .banner-imgs li {
    border-radius: 8px;
    height: 224px;
    margin-right: 11px;
    overflow: hidden;
  }
  .banner-imgs li img {
    display: block;
    height: 100%;
  }
}
</style>
